<div class="cu--top">
  <button
    class="button button--style-primary rounded-4 padding-x-8 rounded-4 h-20"
    [routerLink]="config().navigation?.backLink ?? ['/cases']"
  >
    <svg-icon
      class="flex items-center justify-center"
      src="assets/icons/ui/arrow.svg"
      [svgStyle]="{ transform: 'rotate(-90deg)' }"
    />
    {{ config().navigation?.backText ?? "Back to cases" }}
  </button>
  <app-fairness-button href="/provably-fair/caseopening"></app-fairness-button>
</div>
<div class="cu--panel">
  <div class="cu--panel__skin">
    <div class="cu--panel__skin-column">
      <img
        class="cu--panel__skin-image"
        width="65"
        height="65"
        loading="lazy"
        decoding="async"
        [src]="caseItem().image"
        [alt]="caseItem().name"
        [class.locked]="config().caseItem.locked"
      />
      @if (config().caseItem.locked) {
      <svg-icon
        class="cu--panel__skin-lock absolute-center flex items-center justify-center s-24"
        src="assets/icons/ui/lock.svg"
      ></svg-icon>
      }
    </div>
    <div class="cu--panel__skin-column">
      <span class="cu--panel__skin-name">{{ caseItem().name }}</span>
      <div
        class="cu--panel__skin-price"
        [class.locked]="config().caseItem.locked"
      >
        @if (config().caseItem.detailsType === 'price') {
        <app-balance-icon
          [balance]="config().balanceType"
          color="var(--yellow)"
        />
        {{ caseItem().price | number : "1.2-2" }}
        } @else {
        {{ caseItem().category }}
        }
      </div>
    </div>
  </div>
  @if (config().spinner.amount) {
  <div class="cu--panel__spinners">
    <button
      [class.active]="1 === spinnersAmount()"
      (click)="handleChangeSpinnersAmount(1)"
      [disabled]="isSpinning()"
    >
      {{ 1 }}
    </button>
    <button
      [class.active]="2 === spinnersAmount()"
      (click)="handleChangeSpinnersAmount(2)"
      [disabled]="isSpinning()"
    >
      {{ 2 }}
    </button>
    <button
      [class.active]="3 === spinnersAmount()"
      (click)="handleChangeSpinnersAmount(3)"
      [disabled]="isSpinning()"
    >
      {{ 3 }}
    </button>
    <button
      [class.active]="4 === spinnersAmount()"
      (click)="handleChangeSpinnersAmount(4)"
      [disabled]="isSpinning()"
    >
      {{ 4 }}
    </button>
  </div>
  }
  <div class="cu--panel__fast-spin">
    <app-checkbox [(checked)]="fastOpen" [disabled]="isSpinning()">
      Fast Spin
    </app-checkbox>
  </div>
  <div class="cu--panel__buttons">
    <button
      class="cu--panel__open"
      (click)="handleOpenCase()"
      [disabled]="isSpinning() || !!config().openButton?.disabled"
    >
      @if (config().openButton) {
      {{ config().openButton!.text }}
      } @else {
      <!--  -->
      Open @if (config().caseItem.detailsType === 'price') { For
      <app-balance-icon [balance]="config().balanceType" color="var(--black)" />
      {{ caseItem().price * spinnersAmount() | number : "1.2-2" }}
      }
      <!--  -->
      }
    </button>
    <button
      class="cu--panel__demo"
      (click)="handleStartDemoSpin()"
      [disabled]="isSpinning()"
    >
      Demo Spin
    </button>
  </div>
</div>

<div class="cu--spinners" [@staggerList]="spinners().length">
  @for (spinner of spinners(); track $index; let first = $first; let index =
  $index) {
  <app-case-spinner
    [accentColor]="
      index === 1
        ? 'var(--green)'
        : index === 2
        ? 'var(--red)'
        : index === 3
        ? 'var(--purple)'
        : 'var(--yellow)'
    "
    [playSound]="first"
    [isFastSpin]="fastOpen()"
    [currentCase]="caseItem()"
    [balanceType]="config().balanceType"
  ></app-case-spinner>
  }
</div>

<div class="cu--skins" [@fadeIn]>
  <app-skins-list
    [skins]="caseItem().skins"
    [balanceType]="config().balanceType"
    [config]="{
      mobile: {
        padding: '8px',
      },
    }"
  ></app-skins-list>
</div>
